import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Phase 18: Public Onboarding - Start Screen
 * First screen for new users setting up Hayat system
 */
function PublicOnboardingStart() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050816] flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Logo */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl bg-gradient-to-br from-[#5B4B8A] to-[#4a3d72] mb-6 shadow-2xl">
            <span className="text-5xl">💙</span>
          </div>
          <h1 className="text-5xl font-bold text-[#F9FAFB] mb-3">
            Willkommen bei
          </h1>
          <h2 className="text-6xl font-bold bg-gradient-to-r from-[#6DCEE8] to-[#5B4B8A] bg-clip-text text-transparent">
            HAYAT
          </h2>
        </div>

        {/* Content Card */}
        <div className="bg-neutral-900/80 backdrop-blur-xl rounded-2xl p-8 shadow-2xl border border-neutral-600/40 mb-6 animate-scale-in">
          <h3 className="text-2xl font-bold text-[#F9FAFB] mb-4">
            Was ist Hayat?
          </h3>
          <div className="space-y-4 text-[#CBD5F5]">
            <p className="text-lg">
              Hayat verbindet Familien über Generationen hinweg. Mit Hayat bleiben Sie in Kontakt mit Ihren Liebsten – einfach, sicher und liebevoll.
            </p>
            <div className="grid gap-3 mt-6">
              <div className="flex items-start gap-3 p-3 bg-neutral-800/50 rounded-xl">
                <span className="text-2xl">📱</span>
                <div>
                  <p className="font-bold text-[#6DCEE8]">Einfache Bedienung</p>
                  <p className="text-sm text-neutral-400">Speziell für Senioren entwickelt</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 bg-neutral-800/50 rounded-xl">
                <span className="text-2xl">📞</span>
                <div>
                  <p className="font-bold text-[#6DCEE8]">Video-Telefonie</p>
                  <p className="text-sm text-neutral-400">Gesicht zu Gesicht sprechen</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 bg-neutral-800/50 rounded-xl">
                <span className="text-2xl">⏰</span>
                <div>
                  <p className="font-bold text-[#6DCEE8]">Erinnerungen</p>
                  <p className="text-sm text-neutral-400">Medikamente, Termine & mehr</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-4">
          <button
            onClick={() => navigate('/family/onboarding/household')}
            className="w-full py-5 bg-gradient-to-r from-[#6DCEE8] to-[#5ab4cc] text-[#050816] rounded-xl font-bold text-xl shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300"
          >
            🚀 Los geht's!
          </button>
          <button
            onClick={() => navigate('/family/login')}
            className="w-full py-4 bg-neutral-800/50 text-[#CBD5F5] rounded-xl font-semibold text-base border border-neutral-600/40 hover:bg-neutral-800 transition-all"
          >
            ← Zurück zur Anmeldung
          </button>
        </div>
      </div>
    </div>
  );
}

export default PublicOnboardingStart;
